<template>
  <div class="fd-list-page">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Transit / Trámites en Proceso</p>
            <h1 class="list-title">Trámites en Proceso</h1>
            <p class="list-subtitle">
              Revise, apruebe o rechace los trámites en proceso ante los órganos
              anuentes.
            </p>
          </div>
        </v-flex>

        <!-- ===== Filtro ===== -->
        <v-flex xs12>
          <v-card class="fd-card">
            <v-card-text class="fd-filter">
              <p class="fd-section">Búsqueda</p>
              <v-layout row wrap>
                <v-flex md4 sm6 xs12>
                  <label class="fd-label">N° de Factura</label>
                  <v-text-field
                    v-model="filter.term"
                    class="fd-input"
                    append-icon="search"
                    placeholder="N° factura, control..."
                    clearable
                    solo
                    flat
                    hide-details
                    @keyup.enter="onSearch"
                  ></v-text-field>
                </v-flex>
                <v-flex md4 sm6 xs12>
                  <label class="fd-label">Laboratorio</label>
                  <v-select
                    v-model="filter.labId"
                    class="fd-input"
                    :items="laboratories"
                    item-text="name"
                    item-value="id"
                    placeholder="Todos"
                    no-data-text="Datos no disponibles"
                    clearable
                    solo
                    flat
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex md4 sm6 xs12>
                  <label class="fd-label">Distribuidor</label>
                  <v-select
                    v-model="filter.distId"
                    class="fd-input"
                    :items="distributors"
                    item-text="name"
                    item-value="id"
                    placeholder="Todos"
                    no-data-text="Datos no disponibles"
                    clearable
                    solo
                    flat
                    hide-details
                    @change="onChangeDistributor"
                  ></v-select>
                </v-flex>
              </v-layout>

              <p class="fd-section fd-section--spaced">Fecha</p>
              <v-layout row wrap>
                <v-flex md4 sm6 xs12>
                  <label class="fd-label">Desde</label>
                  <v-menu
                    v-model="modal.startDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.startDate"
                        v-on="on"
                        class="fd-input"
                        append-icon="event"
                        placeholder="Fecha inicial"
                        readonly
                        clearable
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.startDate"
                      locale="es-es"
                      color="#254f87"
                      scrollable
                      @input="modal.startDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md4 sm6 xs12>
                  <label class="fd-label">Hasta</label>
                  <v-menu
                    v-model="modal.endDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.endDate"
                        v-on="on"
                        class="fd-input"
                        append-icon="event"
                        placeholder="Fecha final"
                        readonly
                        clearable
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.endDate"
                      locale="es-es"
                      color="#254f87"
                      scrollable
                      @input="modal.endDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex md4 sm12 xs12 class="fd-filter__actions">
                  <button class="fd-btn fd-btn--ghost" @click="clearFilter">
                    <v-icon small class="fd-btn__icon">filter_alt_off</v-icon>
                    Limpiar
                  </button>
                  <button class="fd-btn fd-btn--secondary" @click="onSearch">
                    <v-icon small class="fd-btn__icon">search</v-icon>
                    Buscar
                  </button>
                  <button class="fd-btn fd-btn--export" @click="onDownload">
                    <v-icon small class="fd-btn__icon">cloud_download</v-icon>
                    Exportar
                  </button>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- ===== Tabla ===== -->
        <v-flex xs12>
          <v-card class="fd-card">
            <div class="fd-toolbar">
              <div class="fd-toolbar__info">
                <!-- Cuenta trámites, como las demás bandejas; las facturas
                     van aparte solo si hay consolidados en la búsqueda. -->
                <span class="fd-chip">
                  <v-icon small class="fd-chip__icon">description</v-icon>
                  {{ meta.totalGroups }} en proceso
                  <template v-if="meta.totalInvoices !== meta.totalGroups">
                    ({{ meta.totalInvoices }} facturas)
                  </template>
                </span>
              </div>
            </div>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div class="table-wrap">
                <table class="fd-table">
                  <thead>
                    <tr>
                      <th># Factura</th>
                      <th>Distribuidor</th>
                      <th>Laboratorio</th>
                      <th>Órgano Anuente</th>
                      <th>Fecha de Ingreso</th>
                      <th>Control de Trámite</th>
                      <th class="th-center">TAT de Aprobación</th>
                      <th class="th-center">Detalles</th>
                      <th class="th-center">Aprobar / Rechazar</th>
                    </tr>
                  </thead>
                  <!-- Un <tbody> por trámite, como en Contabilidad: la banda
                       con el consecutivo y, debajo, una fila por factura. El
                       grupo entero se realza junto al pasar el cursor. -->
                  <tbody
                    v-for="group in groups"
                    :key="group.key"
                    class="fd-group"
                  >
                    <!-- Banda del trámite (texto de TramiteBand). Solo
                         texto: aprobar y rechazar van una sola vez dentro del
                         trámite, en su columna. El individual va en tono
                         neutro. -->
                    <tr
                      class="fd-group-row"
                      :class="{ 'fd-group-row--single': !esConsolidado(group) }"
                    >
                      <td colspan="9">
                        <v-icon small class="fd-group-row__icon">
                          {{ esConsolidado(group) ? 'layers' : 'description' }}
                        </v-icon>
                        {{ etiquetaTramite(group) }}
                        <strong>{{ consecutivoDe(group) }}</strong>
                        &middot; {{ facturasDe(group) }}
                        <span
                          v-if="esConsolidado(group)"
                          class="fd-group-row__muted"
                        >
                          &middot; CIF total {{ money(cifTramiteDe(group)) }}
                        </span>
                        <span
                          v-if="controlFdDe(group)"
                          class="fd-group-row__muted"
                        >
                          &middot; Control F&amp;D: {{ controlFdDe(group) }}
                        </span>
                        <!-- Solo en el consolidado, como antes: una factura
                             individual con varios órganos ya los lista en su
                             fila y no es un amarre que revisar. -->
                        <span
                          v-if="esConsolidado(group) && group.multipleOrganos"
                          class="fd-group-row__warn"
                          :title="group.organosAnuentes.join(', ')"
                        >
                          &middot; varios órganos anuentes
                        </span>
                      </td>
                    </tr>

                    <tr
                      v-for="(item, index) in group.invoices"
                      :key="item.id"
                      :class="{ 'fd-child-row': esConsolidado(group) }"
                    >
                      <td class="fd-cell--strong">
                        {{ item.invoiceNumber || '—' }}
                      </td>
                      <td>{{ distName(item) }}</td>
                      <td>{{ labName(item) }}</td>
                      <td>
                        <div
                          v-if="
                            item.organosAnuentes && item.organosAnuentes.length
                          "
                          class="organo-list"
                        >
                          <span
                            v-for="o in item.organosAnuentes"
                            :key="o.id"
                            class="organo-tag"
                          >
                            {{ o.name }}
                          </span>
                        </div>
                        <span v-else class="fd-muted">—</span>
                      </td>
                      <td class="fd-nowrap">
                        <span v-if="item.admissionDate">
                          {{ dateFormat(item.admissionDate) }}
                        </span>
                        <span
                          v-else
                          class="fd-muted"
                          title="Se fija al asignar el control de trámite"
                        >
                          Al asignar control
                        </span>
                      </td>
                      <td>
                        <v-edit-dialog
                          :return-value.sync="item.fdcontrolNumber"
                          lazy
                          large
                          persistent
                          save-text="Guardar"
                          cancel-text="Cancelar"
                          @save="handleControlNumber(item)"
                        >
                          <span class="fd-control">
                            {{ item.fdcontrolNumber || 'Asignar...' }}
                            <v-icon x-small class="fd-control__icon"
                              >edit</v-icon
                            >
                          </span>
                          <template v-slot:input>
                            <v-text-field
                              v-model="item.fdcontrolNumber"
                              label="N° de control de trámite"
                              single-line
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="th-center">
                        <span
                          class="fd-days"
                          title="Días laborables desde el ingreso, sin fines de semana ni feriados"
                        >
                          {{ item.totalInTransit }}
                          <small>días</small>
                        </span>
                      </td>
                      <td class="th-center">
                        <v-btn
                          class="btn-detail"
                          icon
                          small
                          title="Ver detalles"
                          @click="handleDetails(item)"
                        >
                          <v-icon small>visibility</v-icon>
                        </v-btn>
                      </td>
                      <!-- Una sola vez por trámite: en un consolidado la celda
                           abarca todas sus facturas, porque se aprueba o
                           rechaza entero. El tooltip y la confirmación dicen
                           el alcance antes de tocar nada. -->
                      <td
                        v-if="celdaTramite(group, index)"
                        :rowspan="filasTramite(group)"
                        class="th-center"
                        :class="{ 'fd-cell--tramite': esConsolidado(group) }"
                      >
                        <div class="action-group">
                          <v-btn
                            class="btn-approve"
                            icon
                            small
                            :title="aprobarTitle(group)"
                            @click="approveFrom(group, item)"
                          >
                            <v-icon small>check</v-icon>
                          </v-btn>
                          <v-btn
                            class="btn-reject"
                            icon
                            small
                            :title="rechazarTitle(group)"
                            @click="rejectFrom(group, item)"
                          >
                            <v-icon small>block</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="!pagination.loading && groups.length === 0">
                    <tr>
                      <td colspan="9" class="empty-state">
                        No se encontraron facturas con los filtros aplicados.
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="pagination.loading">
                    <tr>
                      <td colspan="9" class="empty-state">Cargando...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="pagination.pages">
          <div class="list-footer">
            <div class="list-footer__count">
              Mostrando {{ groups.length }} de {{ meta.totalGroups }} trámites
              ({{ meta.totalInvoices }}
              facturas)
            </div>
            <v-pagination
              v-model="pagination.page"
              :length="pagination.pages"
              :total-visible="7"
              color="#254f87"
              @input="asyncPagination"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- ===== Diálogo: aprobar una factura ===== -->
    <v-dialog v-model="approveOne.show" max-width="420" persistent>
      <v-card class="approve-card approve-card--single">
        <div class="approve-card__icon approve-card__icon--center">
          <v-icon>task_alt</v-icon>
        </div>
        <div class="approve-card__single-body">
          <h2 class="approve-card__title">
            {{ approveOne.group ? 'Aprobar consolidado' : 'Aprobar factura' }}
          </h2>
          <p class="approve-card__subtitle">
            <template v-if="approveOne.group">
              Se aprobarán las
              {{ approveOne.group.invoices.length }} facturas del consolidado y
              se enviará la notificación por correo.
            </template>
            <template v-else>
              La factura será aprobada y se enviará la notificación por correo.
            </template>
          </p>
          <p v-if="approveOne.item" class="approve-card__item">
            {{ approveOne.item.invoiceNumber }}
          </p>
          <template v-if="approveOne.group">
            <p class="approve-card__item">
              {{ consecutivoDe(approveOne.group) }}
            </p>
            <p class="approve-card__list">
              {{
                approveOne.group.invoices.map(i => i.invoiceNumber).join(', ')
              }}
            </p>
          </template>
        </div>
        <div class="approve-card__single-actions">
          <button
            class="fd-btn fd-btn--ghost"
            :disabled="approveOne.loading"
            @click="approveOne.show = false"
          >
            Cancelar
          </button>
          <button
            class="fd-btn fd-btn--approve"
            :class="{ 'is-loading': approveOne.loading }"
            :disabled="approveOne.loading"
            @click="approveOne.group ? doApproveGroup() : doApproveOne()"
          >
            <span v-if="approveOne.loading" class="approve-spinner"></span>
            <span v-else>Aprobar</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :key="detail.key"
        v-on:close-detail="detail.show = false"
        :item="detail.data"
      ></compose>
    </v-dialog>

    <v-dialog max-width="560" v-if="rejected.data" v-model="rejected.show">
      <rejected
        :key="rejected.key"
        v-on:save-rejected="handleSaved"
        v-on:close-rejected="rejected.show = false"
        :item="rejected.data"
        :invoices="rejected.invoices"
        :code="rejected.code"
      ></rejected>
    </v-dialog>

    <v-dialog max-width="500" v-if="attachment.data" v-model="attachment.show">
      <attachment
        :key="attachment.key"
        v-on:close-attach="attachment.show = false"
        :item="attachment.data"
      ></attachment>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar
      v-model="snack.show"
      :timeout="5000"
      :color="snack.color"
      right
      top
    >
      {{ snack.message }}
      <v-btn flat dark @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import compose from './../dialog/DialogDetails'
import rejected from './../dialog/DialogRejected'
import loading from './../dialog/DialogLoading'
import attachment from './../dialog/DialogAttachment'
import message from './../dialog/Message'
import SessionHelper from '@/helpers/SessionHelper'
import { dateFormat } from '@/helpers/TransitHelper'
import TramiteBand from './mixins/TramiteBand'

export default {
  // La banda del trámite se lee igual que en Contabilidad y el resto de
  // Transit (consecutivo CONS-/IND-, facturas, CIF y control F&D).
  mixins: [TramiteBand],
  components: {
    compose,
    rejected,
    loading,
    attachment,
    message,
  },
  data() {
    return {
      // El backend devuelve los tramites ya agrupados por consolidado, igual
      // que Listado de Facturas y la bandeja de pendientes.
      groups: [],
      meta: { totalGroups: 0, totalInvoices: 0 },
      snack: {
        show: false,
        color: 'info',
        message: '',
      },
      dialog: {
        show: null,
        key: 0,
      },
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      modal: {
        startDate: false,
        endDate: false,
      },
      distributors: [],
      laboratories: [],
      filter: {
        distId: '',
        labId: '',
        startDate: '',
        endDate: '',
        term: '',
      },
      attachment: {
        show: null,
        data: null,
        key: 0,
      },
      detail: {
        show: null,
        data: null,
        key: 0,
      },
      rejected: {
        show: null,
        data: null,
        // Cuando se rechaza un consolidado, las facturas del grupo y su código.
        invoices: null,
        code: null,
        key: 0,
      },
      approveOne: {
        show: false,
        loading: false,
        item: null,
        // Cuando se aprueba un consolidado completo en vez de una factura.
        group: null,
      },
    }
  },
  created() {
    this.loadDistributors()
    this.asyncPagination()
  },
  methods: {
    dateFormat,
    labName(item) {
      return item.laboratorio || '—'
    },
    distName(item) {
      return item.distribuidor || '—'
    },
    notify(message, color = 'info') {
      this.snack = { show: true, color, message }
    },
    loadDistributors() {
      this.$store.dispatch('distributors/getAll', {}).then(response => {
        const data = (response && response.items) || []
        this.distributors = data.map(d => ({ name: d.name, id: d.id }))
      })
    },
    onChangeDistributor(id) {
      this.laboratories = []
      this.filter.labId = ''
      if (!id) return
      this.$store.dispatch('distributors/getById', { id }).then(response => {
        const data = (response && response.laboratories) || []
        this.laboratories = data.map(l => ({ name: l.name, id: l.id }))
      })
    },
    clearFilter() {
      this.filter = {
        distId: '',
        labId: '',
        startDate: '',
        endDate: '',
        term: '',
      }
      this.laboratories = []
      this.onSearch()
    },
    helperPaginate(response) {
      this.groups = (response && response.groups) || []
      this.meta = {
        totalGroups: (response && response.totalGroups) || 0,
        totalInvoices: (response && response.totalInvoices) || 0,
      }
      // Se pagina por GRUPO: un consolidado nunca queda partido entre paginas.
      this.pagination.totalItems = this.meta.totalInvoices
      this.pagination.pages =
        Math.ceil(this.meta.totalGroups / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },

    buildFilter(extra = {}) {
      return {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'fd',
        sortBy: 'admissionDate',
        ...this.pagination.search,
        ...extra,
      }
    },
    asyncPagination() {
      this.pagination.loading = true
      return new Promise(resolve => {
        this.$store
          .dispatch('invoices/getConsolidated', this.buildFilter())
          .then(response => {
            this.helperPaginate(response)
            return resolve()
          })
      })
    },
    onSearch() {
      const params = { ...this.filter }
      Object.keys(params).forEach(key => {
        if (params[key] == null || params[key] === '') delete params[key]
      })
      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'fd',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
    // ===== Aprobación por factura =====
    async runApprove(ids) {
      if (!ids || !ids.length) return
      await this.$store.dispatch('transit/approve', {
        invoices: ids,
        sendEmails: true,
      })
    },
    confirmApproveOne(item) {
      this.approveOne = { show: true, loading: false, item, group: null }
    },
    // La columna Acciones lleva los mismos iconos en todas las filas. Lo que
    // cambia es el alcance: en un consolidado el trámite se aprueba o rechaza
    // entero (aprobar facturas sueltas dejaría el grupo con estados
    // distintos), así que desde cualquiera de sus filas se actúa sobre todas.
    approveFrom(group, item) {
      if (this.esConsolidado(group)) {
        this.confirmApproveGroup(group)
        return
      }
      this.confirmApproveOne(item)
    },
    rejectFrom(group, item) {
      if (this.esConsolidado(group)) {
        this.rejectGroup(group)
        return
      }
      this.handleReject(item)
    },
    aprobarTitle(group) {
      return this.esConsolidado(group)
        ? `Aprobar el consolidado completo (${group.invoices.length} facturas)`
        : 'Aprobar esta factura'
    },
    rechazarTitle(group) {
      return this.esConsolidado(group)
        ? `Rechazar el consolidado completo (${group.invoices.length} facturas)`
        : 'Rechazar esta factura'
    },
    // Aprobar todo un consolidado: el trámite es uno solo, aprobar facturas
    // sueltas dejaría el grupo con estados distintos.
    confirmApproveGroup(group) {
      this.approveOne = { show: true, loading: false, item: null, group }
    },
    doApproveGroup() {
      const group = this.approveOne.group
      if (!group) return
      const ids = group.invoices.map(i => i.id)
      this.approveOne.loading = true
      this.runApprove(ids)
        .then(() => this.asyncPagination())
        .then(() => {
          this.approveOne = {
            show: false,
            loading: false,
            item: null,
            group: null,
          }
          this.notify(
            `El consolidado ${this.consecutivoDe(
              group
            )} fue aprobado con sus ` + `${ids.length} facturas.`,
            'success'
          )
        })
        .catch(() => {
          this.approveOne.loading = false
          this.notify('No se pudo aprobar el consolidado.', 'error')
        })
    },
    // Rechazar todo un consolidado: el diálogo recibe las facturas del grupo y
    // manda un solo rechazo con la misma observación y soporte.
    rejectGroup(group) {
      this.rejected = {
        data: group.invoices[0],
        invoices: group.invoices,
        code: this.consecutivoDe(group),
        show: true,
        key: this.rejected.key + 1,
      }
    },
    doApproveOne() {
      const item = this.approveOne.item
      if (!item) return
      this.approveOne.loading = true
      this.runApprove([item.id])
        .then(() => this.asyncPagination())
        .then(() => {
          this.approveOne = { show: false, loading: false, item: null }
          this.notify('La factura fue aprobada.', 'success')
        })
        .catch(() => {
          this.approveOne.loading = false
          this.notify('No se pudo aprobar la factura.', 'error')
        })
    },
    // ===== Otros =====
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            // El listado agrupado trae laboratorio/distribuidor como texto,
            // pero DialogDetails espera lab_invoices/dist_invoices.
            data: {
              ...row,
              lab_invoices: { id: row.labId, name: row.laboratorio },
              dist_invoices: { id: row.distId, name: row.distribuidor },
              products: items ? items : null,
            },
            show: true,
            key: this.detail.key + 1,
          }
        })
    },
    handleReject(row) {
      this.rejected = {
        data: row,
        invoices: null,
        code: null,
        show: true,
        key: this.rejected.key + 1,
      }
    },
    handleSaved() {
      const code = this.rejected.code
      const count = this.rejected.invoices ? this.rejected.invoices.length : 1
      this.rejected.show = false
      this.loading = true
      this.asyncPagination().then(() => {
        this.notify(
          code
            ? `El consolidado ${code} fue rechazado con sus ${count} facturas.`
            : 'La factura fue rechazada.',
          'primary'
        )
      })
    },
    handleControlNumber(row) {
      this.$store
        .dispatch('transit/controlNumber', {
          controlNumber: row.fdcontrolNumber,
          invoicesID: row.id,
        })
        .then(() => {
          // El backend fija la fecha de ingreso (admissionDate) al asignar el
          // control; se refleja aquí de inmediato sin recargar la lista.
          if (!row.admissionDate) {
            row.admissionDate = moment().format('YYYY-MM-DD')
          }
          this.notify('El número de control fue actualizado.', 'success')
        })
    },
  },
}
</script>

<style scoped>
.fd-list-page {
  background: #f8fafc;
  min-height: 100vh;
  padding-bottom: 16px;
}

/* === Hero === */
.list-hero {
  padding: 4px 0 8px;
}

.list-crumb {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.list-title {
  margin: 4px 0;
  font-size: 32px;
  line-height: 1.1;
  color: #0f172a;
  font-weight: 700;
}

.list-subtitle {
  margin: 0;
  font-size: 14px;
  color: #475569;
  max-width: 760px;
}

/* === Card === */
.fd-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  background: #ffffff;
}

/* === Filtro === */
.fd-filter {
  padding: 16px;
}

.fd-section {
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #254f87;
}
.fd-section--spaced {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.fd-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  letter-spacing: 0.01em;
}

.fd-filter__actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

/* === Botones === */
.fd-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.18s ease;
  text-transform: none;
}

.fd-btn__icon {
  font-size: 16px !important;
}

.fd-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.fd-btn--ghost {
  background: #ffffff;
  color: #475569;
  border-color: #e2e8f0;
}

.fd-btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.fd-btn--secondary {
  background: rgba(37, 79, 135, 0.1);
  color: #254f87;
  border-color: rgba(37, 79, 135, 0.3);
}

.fd-btn--secondary:hover:not(:disabled) {
  background: rgba(37, 79, 135, 0.18);
}

.fd-btn--export {
  background: #ffffff;
  color: #16a34a;
  border-color: #bbf7d0;
}

.fd-btn--export:hover:not(:disabled) {
  background: #f0fdf4;
  border-color: #86efac;
}

.fd-btn--approve {
  background: #16a34a;
  color: #ffffff;
  border-color: #16a34a;
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.25);
}

.fd-btn--approve:hover:not(:disabled) {
  background: #15803d;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.32);
  transform: translateY(-1px);
}

.fd-btn--approve.is-loading {
  pointer-events: none;
}

/* === Toolbar tabla === */
.fd-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  flex-wrap: wrap;
}

.fd-toolbar__info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.fd-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fd-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  background: #f1f5f9;
  color: #475569;
}

.fd-chip__icon {
  font-size: 15px !important;
  color: #64748b !important;
}

.fd-chip--accent {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.fd-chip--accent .fd-chip__icon {
  color: #16a34a !important;
}

/* === Tabla === */
.table-wrap {
  width: 100%;
  overflow-x: auto;
}

.fd-table {
  width: 100%;
  border-collapse: collapse;
}

.fd-table thead tr {
  background: #f8fafc;
}

/* Tamaño de Contabilidad (igual que transit-list.css): el cliente pidió que
   todas las listas se vean idénticas ("está muy pequeña para la vista"). */
.fd-table th,
.fd-table td {
  text-align: left;
  color: #334155;
  padding: 12px 14px;
  border-bottom: 1px solid #eef2f7;
  font-size: 15px;
  vertical-align: middle;
}

.fd-table th {
  font-size: 13px;
  letter-spacing: 0.2px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
}

.fd-table tbody tr:hover {
  background: #f8fafc;
}

.fd-table tbody tr.is-selected {
  background: rgba(37, 79, 135, 0.06);
}

.th-check {
  width: 56px;
}

.th-center {
  text-align: center;
}

.th-actions {
  width: 150px;
  text-align: right;
}

.fd-cell--strong {
  font-weight: 700;
  color: #0f172a;
}

.fd-check {
  margin: 0 !important;
  padding: 0 !important;
}

.fd-days {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  gap: 3px;
  min-width: 30px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef2f7;
  color: #334155;
  font-size: 12.5px;
  font-weight: 700;
}
.fd-days small {
  font-size: 10px;
  font-weight: 500;
  opacity: 0.7;
}

.fd-nowrap {
  white-space: nowrap;
}
.fd-muted {
  color: #94a3b8;
  font-size: 12.5px;
}

/* Encabezado de un consolidado: separa el grupo del resto de la tabla. */
.fd-group-row td {
  background: #eef2f7;
  color: #254f87;
  font-size: 14px;
  border-top: 2px solid #cbd5e1;
}
/* Encabezado de un tramite individual: mismo bloque, tono neutro. */
.fd-group-row--single td {
  background: #f8fafc;
  color: #64748b;
}
.fd-group-row--single .fd-group-row__icon {
  color: #94a3b8 !important;
}
.fd-group-row__warn {
  color: #b45309;
  font-weight: 600;
}
/* Datos secundarios de la banda (CIF total, control F&D viejo). */
.fd-group-row__muted {
  color: #94a3b8;
}
/* Un <tbody class="fd-group"> por trámite: el grupo entero (banda +
   facturas) se realza junto, como en Contabilidad. */
/* Acción del consolidado: una celda que abarca todas sus facturas. El borde
   la separa de la última columna por factura y la lee como del bloque. */
.fd-cell--tramite {
  border-left: 1px solid #e2e8f0;
}
.fd-group:hover td {
  background: #f1f5f9;
}
.fd-group:hover .fd-group-row td {
  background: #e2e8f0;
}
.approve-card__list {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

.fd-group-row__icon {
  color: #254f87 !important;
  margin-right: 4px;
  vertical-align: middle;
}
.fd-child-row td:first-child {
  padding-left: 22px;
  border-left: 3px solid #cbd5e1;
}

/* Órgano Anuente: varios por trámite en un consolidado. */
.organo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.organo-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eef2f7;
  color: #254f87;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.fd-control {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: #254f87;
  font-weight: 600;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px dashed #cbd5e1;
  transition: all 0.15s ease;
}

.fd-control:hover {
  background: rgba(37, 79, 135, 0.08);
  border-color: #254f87;
}

.fd-control__icon {
  color: #94a3b8 !important;
}

.empty-state {
  text-align: center !important;
  color: #64748b;
  padding: 22px !important;
}

.action-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.btn-detail {
  border: 1px solid rgba(37, 79, 135, 0.3) !important;
  color: #254f87 !important;
  background: rgba(37, 79, 135, 0.1) !important;
  box-shadow: none !important;
}

.btn-approve {
  border: 1px solid rgba(22, 163, 74, 0.3) !important;
  color: #16a34a !important;
  background: rgba(22, 163, 74, 0.1) !important;
  box-shadow: none !important;
}

.btn-approve:hover {
  background: rgba(22, 163, 74, 0.2) !important;
}

.btn-reject {
  border: 1px solid rgba(229, 37, 42, 0.25) !important;
  color: #e5252a !important;
  background: rgba(229, 37, 42, 0.07) !important;
  box-shadow: none !important;
}

.btn-reject:hover {
  background: rgba(229, 37, 42, 0.16) !important;
}

/* === Footer === */
.list-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.list-footer__count {
  font-size: 13px;
  color: #64748b;
}

/* === Diálogo aprobar === */
.approve-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding: 0;
}

.approve-card__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 22px 24px 8px;
}

.approve-card__icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(22, 163, 74, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.approve-card__icon .v-icon {
  color: #16a34a !important;
  font-size: 26px !important;
}

.approve-card__icon--center {
  margin: 24px auto 0;
}

.approve-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.approve-card__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.approve-card__options {
  padding: 12px 24px 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.approve-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.16s ease;
}

.approve-option:hover:not(:disabled) {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.04);
  transform: translateY(-1px);
}

.approve-option:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.approve-option__main {
  display: flex;
  align-items: center;
  gap: 12px;
}

.approve-option__icon {
  color: #254f87 !important;
}

.approve-option--all .approve-option__icon {
  color: #16a34a !important;
}

.approve-option__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #172133;
}

.approve-option__help {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.approve-option__count {
  flex-shrink: 0;
  min-width: 32px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.approve-card__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 20px;
}

.approve-card__busy {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #64748b;
  margin-right: auto;
}

.approve-card__single-body {
  text-align: center;
  padding: 14px 28px 4px;
}

.approve-card__item {
  margin: 10px 0 0;
  font-size: 13.5px;
  font-weight: 700;
  color: #334155;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 6px 12px;
  display: inline-block;
}

.approve-card__single-actions {
  display: flex;
  gap: 10px;
  padding: 18px 28px 24px;
}

.approve-card__single-actions .fd-btn {
  flex: 1;
  height: 42px;
}

.approve-spinner {
  width: 16px;
  height: 16px;
  border: 2.5px solid rgba(22, 163, 74, 0.3);
  border-top-color: #16a34a;
  border-radius: 50%;
  animation: approve-spin 0.7s linear infinite;
  display: inline-block;
}

.fd-btn--approve .approve-spinner {
  border-color: rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
}

@keyframes approve-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 959px) {
  .list-title {
    font-size: 26px;
  }
  .fd-filter__actions {
    justify-content: stretch;
  }
  .fd-filter__actions .fd-btn {
    flex: 1;
  }
  .fd-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .fd-toolbar__actions {
    justify-content: flex-end;
  }
  .list-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

<style>
/* === Inputs solo del filtro (no scoped: clases globales de Vuetify) === */
.fd-list-page
  .fd-input.v-text-field.v-text-field--solo
  .v-input__control
  > .v-input__slot,
.fd-list-page
  .fd-input.v-select.v-text-field--solo
  .v-input__control
  > .v-input__slot {
  background: #ffffff !important;
  border: 1px solid #d1d5db !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.fd-list-page .fd-input.v-input--is-focused .v-input__control > .v-input__slot {
  border-color: #254f87 !important;
  box-shadow: 0 0 0 3px rgba(37, 79, 135, 0.12) !important;
}

.fd-list-page .fd-input .v-input__icon .v-icon {
  color: #94a3b8 !important;
  font-size: 19px !important;
}
</style>
